module.exports = __webpack_public_path__ + "static/media/fuel.49cd7110.svg";